module.exports = __webpack_public_path__ + "images/7c82a5a2f9c6b056dfcd2c21cb87d386-landing.jpg";